import { ReactSVG } from "react-svg";
import LogoVesta from "../../assets/logo-vesta-novo.png";
import analise from "../../assets/analise.svg";
import criativo from "../../assets/criativo.svg";
import outsourcing from "../../assets/outsourcing.svg";
import vitrine from "../../assets/vitrine.svg";
import biblioteca from "../../assets/biblioteca.svg";
import socioAmbiental from "../../assets/socioambiental.svg";
import { ContainerPage } from "./style";
import { useNavigate } from "react-router-dom";

export const HomePage = () => {
    const navigate = useNavigate()

    return (
        <ContainerPage>
            <div className="body">
                <div className="div-topo">
                    <img src={LogoVesta} alt="logo" className="logo" />
                    <h2>Selecione o <bold>módulo</bold> que você deseja entrar</h2>
                </div>
                <div className="modulos">
                    <div className="modulo disable">
                        <ReactSVG className="icone" src={analise} />
                        <h4>Análise</h4>
                    </div>
                    <div className="modulo" onClick={() => navigate("/criativo")}>
                        <ReactSVG className="icone" src={criativo} />
                        <h4>Criativo</h4>
                    </div>
                    <div className="modulo" onClick={() => navigate("/dashboard")}>
                        <ReactSVG className="icone" src={outsourcing} />
                        <h4>Outsourcing</h4>
                    </div>
                    <div className="modulo" onClick={() => navigate("/vitrine")}>
                        <ReactSVG className="icone" src={vitrine} />
                        <h4>Vitrine</h4>
                    </div>
                    <div className="modulo disable">
                        <ReactSVG className="icone" src={biblioteca} />
                        <h4>Biblioteca</h4>
                    </div>
                    <div className="modulo disable">
                        <ReactSVG className="icone" src={socioAmbiental} />
                        <h4>Socioambiental</h4>
                    </div>
                </div>
            </div>
        </ContainerPage>
    )
}